import React, {useCallback, useState, useEffect} from 'react';
import {Card, Page, Layout, Form, Frame, FormLayout, Button, TextField, Toast} from '@shopify/polaris';
import createApp from '@shopify/app-bridge';
import {Redirect} from '@shopify/app-bridge/actions';
import {getSessionToken} from "@shopify/app-bridge-utils";

function Support() {
    const [name, setName] = useState(null);
    const [pageJustLoadedName, setPageJustLoadedName] = useState(true);
    const [email, setEmail] = useState(null);
    const [pageJustLoadedEmail, setPageJustLoadedEmail] = useState(true);
    const [subject, setSubject] = useState('Contact Form AutoResponder');
    const [pageJustLoadedSubject, setPageJustLoadedSubject] = useState(true);
    const [message, setMessage] = useState(null);
    const [pageJustLoadedMessage, setPageJustLoadedMessage] = useState(true);
    const [submitError, setSubmitError] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    const [subscription, setSubscription] = useState(null);
    const [config, setConfig] = useState(null);

    const handleNameChange = useCallback((value) => {
        setName(value);
        setPageJustLoadedName(false);
    }, []);
    const handleEmailChange = useCallback((value) => {
        setEmail(value);
        setPageJustLoadedEmail(false);
    }, []);
    const handleSubjectChange = useCallback((value) => {
        setSubject(value);
        setPageJustLoadedSubject(false);
    }, []);
    const handleMessageChange = useCallback((value) => {
        setMessage(value);
        setPageJustLoadedMessage(false);
    }, []);
    const toggleSubmitSuccess = useCallback(() => {
        setSubmitSuccess(false);
    }, []);
    const toggleSubmitError = useCallback(() => {
        setSubmitError(false);
    }, []);

    useEffect(() => {
        fetchSubscription();
    }, []);

    const fetchSubscription = async () => {
        const query = new URLSearchParams(window.location.search);
        const configApp = {
            apiKey: window['apiKey'],
            host: query.get('host'),
            forceRedirect: true
        };
        setConfig(configApp);
        window['bridge-app'] = createApp(configApp);

        const sessionToken = await getSessionToken(window['bridge-app']);
        if (sessionToken) {
            const settings = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionToken
                }
            };
            const response = await fetch('https://contactautoreply.com/api/subscription/current/' + window.$queryString, settings);
            // if user session expired reload the page
            if (response.status === 403) {
                window.location.reload();
                return false;
            }

            // if shop is banned we just show an alert
            if (response.status === 404) {
                alert('Account disabled for suspicious activity!')
                return false;
            }

            const responseJson = await response.json();

            if (response.status === 274) {
                window.location.href = 'https://contactautoreply.com/login/' + window.$queryString;
                return false;
            }
            if (response.status === 275) {
                const redirect = Redirect.create(window['bridge-app']);
                redirect.dispatch(Redirect.Action.REMOTE, responseJson.redirect_url);
                return false;
            }
            setSubscription(responseJson);
        }
    };

    const handleFormSubmit = () => {
        setPageJustLoadedName(false);
        setPageJustLoadedEmail(false);
        setPageJustLoadedSubject(false);
        setPageJustLoadedMessage(false);
        const firstError = document.querySelectorAll('.Polaris-TextField--error');
        if (
            (firstError.length === 0) &&
            name &&
            email &&
            subject &&
            message
        ) {
            setSubmitLoading(true);
            getSessionToken(window['bridge-app'])
                .then((sessionToken) => {
                    const data = {
                        'name': name,
                        'email': email,
                        'subject': subject,
                        'message': message,
                    };
                    fetch('https://contactautoreply.com/api/support/send/', {
                        method: 'POST',
                        body: JSON.stringify(data),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + sessionToken
                        }
                    }).then(response => {
                        if (response.status === 200) {
                            setSubmitSuccess(true);
                        } else {
                            setSubmitError(true);
                        }
                        return response.json();
                    }).then(response => {
                        setSubmitLoading(false);
                    }).catch(err => {
                        setSubmitError(true);
                        setSubmitLoading(false);
                    });
                });
        }
    };

    return (
        <Page
            title="Have any questions?"
            breadcrumbs={[{content: 'Dashboard', url: `/${window.$queryString}`}]}
        >
            <Layout>
                <Layout.Section>
                    <Form onSubmit={handleFormSubmit}>
                        <Frame>
                            <Card title="Please let us know and we will help you immediately" sectioned>
                                <FormLayout>
                                    <TextField label="Name" value={name} type="text"
                                        onChange={handleNameChange}
                                        error={(name || pageJustLoadedName) ? null : "Name is required"}
                                    />
                                    <TextField label="Email" value={email} type="email"
                                        onChange={handleEmailChange}
                                        error={(email || pageJustLoadedEmail) ? null : "Email is required"}
                                    />
                                    <TextField label="Subject" value={subject} type="text"
                                        onChange={handleSubjectChange}
                                        error={(subject || pageJustLoadedSubject) ? null : "Subject is required"}
                                    />
                                    <TextField label="Message Text"
                                        value={message}
                                        multiline={4}
                                        onChange={handleMessageChange}
                                        error={(message || pageJustLoadedMessage) ? null : "Message Text is required"}
                                    />
                                </FormLayout>
                            </Card>
                            <br/>
                            {
                                submitLoading ?
                                    <div className="main-button-wrapper">
                                        <Button submit primary loading>Send</Button>
                                    </div>
                                    :
                                    <div className="main-button-wrapper">
                                        <Button submit primary>Send</Button>
                                    </div>
                            }
                            {
                                submitSuccess ?
                                    <Toast content="Message Sent" onDismiss={toggleSubmitSuccess} />
                                    :
                                    null
                            }
                            {
                                submitError ?
                                    <Toast content="Error While Sending Message" error onDismiss={toggleSubmitError} />
                                    :
                                    null
                            }
                        </Frame>
                    </Form>
                </Layout.Section>
            </Layout>
        </Page>
    );
}

export default Support;
